import { jsx } from 'react/jsx-runtime';
import { Label as Label$1 } from '@cheetahdigital/console-kit-cx';

var Label = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, _c = _a.weight, weight = _c === void 0 ? "regular" : _c, children = _a.children, color = _a.color, isPaddingless = _a.isPaddingless;
    return (jsx(Label$1, { text: children, size: size, color: color, font: { weight: weight }, style: isPaddingless && {
            padding: 0
        } }, void 0));
};

export { Label as default };
